import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormLabel, withStyles } from 'material-ui';
import DateTimePickerWrapperStyles from './DateTimePickerWrapperStyles';
import DatePicker from '../../../date-time-picker/DatePicker';
import './DateTimePicker.css';

const DateTimePickerWrapper = ({ classes, open, label, date, viewDate, dateFormat, onChange }) => (
  <div className={classes.root}>
    <FormControl component='fieldset' className={classes.formControl}>
      <FormLabel focused={open} classes={{ root: classes.formLabel, focused: classes.checked }}>
        {label}
      </FormLabel>
      <DatePicker
        spanClassName=''
        readonly
        value={date}
        alwaysVisible={false}
        viewDate={viewDate}
        locale='en'
        dateFormat={dateFormat}
        showInput={false}
        closeOnSelect
        onChange={onChange}
      />
    </FormControl>
  </div>
);

DateTimePickerWrapper.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  label: PropTypes.string,
  dateFormat: PropTypes.string,
  date: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  onChange: PropTypes.func,
};

export default withStyles(DateTimePickerWrapperStyles)(DateTimePickerWrapper);



// WEBPACK FOOTER //
// ./src/containers/passengers/common/editPassenger/DateTimePickerWrapper.js